// Mock data for initial frontend implementation

import standardImage1 from '../Assests/standard/4.jpeg';
import standardImage2 from '../Assests/standard/5.jpeg';
import standardImage3 from '../Assests/standard/8.jpeg';
import standardImage4 from '../Assests/standard/12.jpeg';


import commercialImage1 from '../Assests/commercial/2.jpeg';
import commercialImage2 from '../Assests/commercial/3.jpeg';
import commercialImage3 from '../Assests/commercial/9.jpeg';
import commercialImage4 from '../Assests/commercial/14.jpeg';

import deepImage1 from '../Assests/deep/1.jpeg';
import deepImage2 from '../Assests/deep/8.jpeg';
import deepImage3 from '../Assests/deep/13.jpeg';

import vacateImage1 from '../Assests/vacate/1.jpeg';
import vacateImage2 from '../Assests/vacate/2.jpeg';
import vacateImage4 from '../Assests/vacate/4.jpeg';

import plasureWash from '../Assests/serviceCategory/2.jpeg';
import carpetImages from '../Assests/serviceCategory/1.jpeg';
import tileCategory from '../Assests/serviceCategory/3.jpeg';
import hardfloor from '../Assests/serviceCategory/4.jpeg';



export const services = [
  {
    id: 'standard',
    name: 'Standard Cleaning',
    tagline: 'Ideal for home maintenance and upkeep',
    description: 'Our standard cleaning service covers all the essential daily cleaning tasks to keep your home fresh and tidy.',
    image: [standardImage1, standardImage3, standardImage2, standardImage4],
    features: [
      'Ideal for home maintenance and upkeep',
      'Covers daily cleaning tasks',
      'Available once-off or on a recurring basis'
    ],
    popular: false
  },
  {
    id: 'commercial',
    name: 'Commercial Cleaning',
    tagline: 'Professional cleaning for businesses',
    description: 'Ideal for regular schedules, special events, office moves or once-off cleans.',
    image: [commercialImage1, commercialImage2, commercialImage3, commercialImage4],
    features: [
      'Ideal for regular schedules, special events, office moves or once-off cleans',
      'Includes general cleaning, restroom cleaning and more',
      'Carpet steam cleaning',
      'Tile & grout cleaning',
      'Hard floors maintenance',
      'Pressure washing',
      'Quote provided after a site visit with no additional fees',
      'Fully customizable'
    ],
    popular: false
  },

  {
    id: 'deep',
    name: 'Deep Cleaning',
    tagline: 'A comprehensive and meticulous cleaning',
    description: 'Perfect for difficult cleaning tasks such as cleaning ovens, window interiors and more.',
    image: [deepImage1, deepImage2, deepImage3],
    features: [
      'A comprehensive and meticulous cleaning',
      'Perfect for difficult cleaning tasks such as cleaning ovens, window interiors and more',
      'Available once-off or on a recurring basis'
    ],
    popular: true
  },
  {
    id: 'vacate',
    name: 'Vacate Cleaning',
    tagline: 'Bond Back Guarantee',
    description: 'Perfect for when you are moving out or if you want a new home freshly cleaned.',
    image: [vacateImage1, vacateImage2, vacateImage4],
    features: [
      'Perfect for when you are moving out or if you want a new home freshly cleaned',
      'Includes a Bond Back Guarantee',
      'Fully customizable'
    ],
    popular: false
  }
  ,
  {
    id: 'pressure-washing',
    name: 'Pressure Washing',
    tagline: 'Restore Surfaces to Like-New Condition',
    description: 'High-pressure cleaning to remove dirt, mould, and stains from outdoor and hard surfaces.',
    image: [plasureWash],
    features: [
      'Ideal for driveways, patios, walls, and pathways',
      'Removes mould, algae, dirt, and built-up grime',
      'Enhances appearance and extends surface lifespan'
    ],
    popular: false
  },
  {
    id: 'carpet-upholstery-steam-cleaning',
    name: 'Carpet & Upholstery Steam Cleaning',
    tagline: 'Deep Clean for a Healthier Home',
    description: 'Professional steam cleaning to remove deep dirt, allergens, and stains from carpets and furniture.',
    image: [carpetImages],
    features: [
      'Deep steam cleaning for carpets and upholstery',
      'Eliminates stains, odours, and allergens',
      'Safe for families, pets, and all fabric types'
    ],
    popular: false
  },
  {
    id: 'tile-grout-cleaning',
    name: 'Tile & Grout Cleaning',
    tagline: 'Bring Back the Original Shine',
    description: 'Specialised cleaning to remove stubborn dirt and stains from tiles and grout lines.',
    image: [tileCategory],
    features: [
      'Restores tiles and grout to their original look',
      'Removes mould, grease, and deep-set dirt',
      'Suitable for kitchens, bathrooms, and floors'
    ],
    popular: false
  },
  {
    id: 'hard-floor-maintenance',
    name: 'Hard Floor Maintenance',
    tagline: 'Protect and Maintain Your Floors',
    description: 'Professional care and maintenance to keep hard floors clean, polished, and long-lasting.',
    image: [hardfloor],
    features: [
      'Cleaning and maintenance for all hard floor types',
      'Enhances durability and appearance',
      'Custom solutions based on floor material'
    ],
    popular: false
  }

];

export const trustReasons = [
  {
    title: 'Equipped',
    description: 'Eco friendly chemicals.',
    icon: 'Tool'
  },
  {
    title: 'Police Checked',
    description: 'Police cleared personnels.',
    icon: 'ShieldCheck'
  },
  {
    title: 'Insured',
    description: 'Public liability insured.',
    icon: 'Shield'
  },
  {
    title: 'Experienced',
    description: 'We ensure that all cleaning staff have years of experience.',
    icon: 'Award'
  }
];

export const howItWorks = [
  {
    step: 1,
    title: 'Get an instant quote',
    description: 'Find your customized quote instantly by completing the booking form.',
    icon: 'Calculator'
  },
  {
    step: 2,
    title: 'Complete your booking',
    description: 'Customize your cleaning service request according to your needs and enjoy a fast check-out process.',
    icon: 'Calendar'
  },
  {
    step: 3,
    title: 'Experience the cleaning magic',
    description: 'Relax as our experienced cleaning professional cleans your space for you on your selected schedule.',
    icon: 'Sparkles'
  },
  {
    step: 4,
    title: 'Leave a review',
    description: 'If you are happy with our service, provide feedback and receive a discount for your next home clean!',
    icon: 'Star'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Sajidh Saferdeen',
    rating: 5,
    date: 'a month ago',
    text: 'I highly recommend Royal Shine cleaning company! They do a fantastic job on my house and bathroom. They are always incredibly quick, the quality of work is excellent, and their pricing is very reasonable. I will definitely keep using them!',
    avatar: 'https://ui-avatars.com/api/?name=Sajidh+Saferdeen&background=4285f4&color=fff'
  },
  {
    id: 2,
    name: 'Christina Street',
    rating: 5,
    date: '3 months ago',
    text: 'Great service from Royal Shine cleaning. They are a friendly and efficient team that are always happy to accommodate your needs. Would highly recommend.',
    avatar: 'https://ui-avatars.com/api/?name=Christina+Street&background=4285f4&color=fff'
  },
  {
    id: 3,
    name: 'Kirsten McClymont',
    rating: 5,
    date: '3 months ago',
    text: 'Highly recommend Royal Shine Cleaning! Krish & his team always do a fantastic job, leaving our home spotless and fresh. They are professional, reliable, and always go above and beyond to do the extra little tasks I ask for. It’s such a pleasure coming home to a beautifully clean house each month.',
    avatar: 'https://ui-avatars.com/api/?name=Kirsten+McClymont&background=4285f4&color=fff'
  },
  {
    id: 4,
    name: 'Phillipa Vandertogt',
    rating: 5,
    date: '3 months ago',
    text: 'I’ve used Royal Shine a few times now and my home has been sparkly clean and fresh every time! The team are also very lovely and easy to deal with. Highly recommend!',
    avatar: 'https://ui-avatars.com/api/?name=Phillipa+Vandertogt&background=4285f4&color=fff'
  },
  {
    id: 5,
    name: 'Nathan Dewey',
    rating: 5,
    date: 'a month ago',
    text: 'Excellent service, Krish came recommended and with good reason. Really efficient with great communication, really pleased with the results.',
    avatar: 'https://ui-avatars.com/api/?name=Nathan+Dewey&background=4285f4&color=fff'
  },
  {
    id: 6,
    name: 'Holly Brooks',
    rating: 5,
    date: '3 months ago',
    text: 'Wonderful cleaning service, very efficient and thorough! Will definitely use this company again.',
    avatar: 'https://ui-avatars.com/api/?name=Holly+Brooks&background=4285f4&color=fff'
  },
  {
    id: 7,
    name: 'Francisca Lantz',
    rating: 5,
    date: '6 months ago',
    text: 'Great cleaning service by the team at Royal Shine. The team are easy to deal with and the cleaning is fantastic. I can highly recommend their services.',
    avatar: 'https://ui-avatars.com/api/?name=Francisca+Lantz&background=4285f4&color=fff'
  },
  {
    id: 8,
    name: 'Elijah Thompson',
    rating: 5,
    date: '3 months ago',
    text: 'The team I had did a fantastic job, thank you guys. I’m definitely hiring them again.',
    avatar: 'https://ui-avatars.com/api/?name=Elijah+Thompson&background=4285f4&color=fff'
  },
  {
    id: 9,
    name: 'Shashmika Sonakjee',
    rating: 5,
    date: '2 months ago',
    text: 'Shani and team are very accommodating and did a fantastic job on end of lease cleaning and regular cleaning.',
    avatar: 'https://ui-avatars.com/api/?name=Shashmika+Sonakjee&background=4285f4&color=fff'
  },
  {
    id: 10,
    name: 'BEV Whittington',
    rating: 5,
    date: '2 months ago',
    text: 'Very professional, personalised service, highly recommended.',
    avatar: 'https://ui-avatars.com/api/?name=BEV+Whittington&background=4285f4&color=fff'
  },
  {
    id: 11,
    name: 'Josie Philips',
    rating: 5,
    date: '2 months ago',
    text: 'Reliable, friendly, good communication - great service all round.',
    avatar: 'https://ui-avatars.com/api/?name=Josie+Philips&background=4285f4&color=fff'
  },
  {
    id: 12,
    name: 'Deanna Pager',
    rating: 5,
    date: '2 weeks ago',
    text: 'Very thorough and friendly service.',
    avatar: 'https://ui-avatars.com/api/?name=Deanna+Pager&background=4285f4&color=fff'
  },
  {
    id: 13,
    name: 'Rachel Shortte',
    rating: 5,
    date: 'a week ago',
    text: 'Krish and the team made our house sparkle. Would highly recommend. They ask if there’s any areas to concentrate on and are happy to go above and beyond. And all for a very reasonable price!',
    avatar: 'https://ui-avatars.com/api/?name=Rachel+Shortte&background=4285f4&color=fff'
  },
  {
    id: 14,
    name: 'chintaka warsha manage',
    rating: 5,
    date: '2 weeks ago',
    text: 'I highly recommend Royal Shine Cleaning! They did an excellent job cleaning our house and paid great attention to detail. Everything was left spotless, fresh, and looking amazing. They were professional, friendly, and very thorough.',
    avatar: 'https://ui-avatars.com/api/?name=chintaka+warsha+manage&background=4285f4&color=fff'
  },
  {
    id: 15,
    name: 'Teresa Simm',
    rating: 5,
    date: '2 months ago',
    text: 'I get a fortnightly clean. They are consistent with their high level of service. Happy to do extra on request also. I would definitely recommend.',
    avatar: 'https://ui-avatars.com/api/?name=Teresa+Simm&background=4285f4&color=fff'
  }
];

export const faqs = [
  {
    question: 'How do I book?',
    answer: 'Booking a cleaning service with Royal Shine is quick and easy! You can book through our website by filling out our online booking form, or you can give us a call or send us an email to schedule your appointment. Our friendly team will be happy to assist you in selecting a convenient date and time for your cleaning service.'
  },
  {
    question: 'How long does a clean take?',
    answer: 'The duration of a cleaning service can vary depending on the amount of time booked or size of your property. Our booking form gives you the choice to book by duration if you have specific areas you need to focus on or you can book by house size if you want the entire home cleaned.'
  },
  {
    question: 'How many people will come to clean?',
    answer: 'We are happy to cater for you! If you would like a smaller or larger team, please let us know prior to job commencement. If no preference is provided, the team assigned and their size is based on availability.'
  },
  {
    question: 'What if I am unhappy with the clean?',
    answer: 'At Royal Shine, we take customer satisfaction seriously, and if you are unhappy with any aspect of our cleaning service, we encourage you to contact us immediately. Our team is committed to resolving any issues and ensuring that you are completely satisfied with our service.'
  },
  {
    question: 'What areas do you service?',
    answer: 'We provide cleaning services across Perth and surrounding suburbs. Contact us to confirm if we service your area.'
  },
  {
    question: 'Do I need to provide cleaning supplies?',
    answer: 'No! Our cleaners come fully equipped with all necessary cleaning supplies and equipment. However, if you have specific products you\'d like us to use, we\'re happy to accommodate.'
  }
];

export const comparisonData = [
  {
    category: 'Cleaning Tasks (All Rooms)',
    tasks: [
      { name: 'Vacuuming', standard: true, deep: true },
      { name: 'Mopping', standard: true, deep: true },
      { name: 'Emptying bins', standard: true, deep: true },
      { name: 'Wiping surfaces', standard: true, deep: true }
    ]
  },
  {
    category: 'Surfaces & Fixtures (All Rooms)',
    tasks: [
      { name: 'Skirting Boards', standard: false, deep: true },
      { name: 'Ceiling Fans', standard: false, deep: true },
      { name: 'Shelves', standard: true, deep: true },
      { name: 'Outside Cabinets', standard: true, deep: true },
      { name: 'Inside Cabinets', standard: false, deep: true },
      { name: 'Blinds', standard: false, deep: true },
      { name: 'Inside Windows and Tracks', standard: false, deep: true },
      { name: 'Wall Marks', standard: false, deep: true },
      { name: 'Exhaust Fans', standard: false, deep: true }
    ]
  },
  {
    category: 'Kitchen / Living',
    tasks: [
      { name: 'Washing Up', standard: true, deep: true },
      { name: 'Stove Top', standard: true, deep: true },
      { name: 'Microwave', standard: true, deep: true },
      { name: 'Sinks', standard: true, deep: true },
      { name: 'Countertops', standard: true, deep: true },
      { name: 'Inside Microwave', standard: false, deep: true },
      { name: 'Inside Oven', standard: false, deep: true }
    ]
  },
  {
    category: 'Bathroom / Laundry',
    tasks: [
      { name: 'Toilet', standard: true, deep: true },
      { name: 'Shower / Bath', standard: true, deep: true },
      { name: 'Sinks', standard: true, deep: true },
      { name: 'Mirrors', standard: true, deep: true }
    ]
  }
];

export const pricingConfig = {
  baseRates: {
    standard: {
      hourly: 60,
      extraHourly: 70,
      rates: {
        "1_1": { onceOff: 120, weekly: 108, fortnightly: 108, monthly: 114 },
        "2_1": { onceOff: 150, weekly: 135, fortnightly: 135, monthly: 143 },
        "3_1": { onceOff: 210, weekly: 189, fortnightly: 189, monthly: 200 },
        "4_1": { onceOff: 270, weekly: 243, fortnightly: 243, monthly: 257 },
        "5_1": { onceOff: 330, weekly: 297, fortnightly: 297, monthly: 314 },

        "2_2": { onceOff: 180, weekly: 162, fortnightly: 162, monthly: 171 },
        "3_2": { onceOff: 240, weekly: 216, fortnightly: 216, monthly: 228 },
        "4_2": { onceOff: 300, weekly: 270, fortnightly: 270, monthly: 285 },
        "5_2": { onceOff: 360, weekly: 324, fortnightly: 324, monthly: 342 },

        "3_3": { onceOff: 270, weekly: 243, fortnightly: 243, monthly: 257 },
        "4_3": { onceOff: 330, weekly: 297, fortnightly: 297, monthly: 314 },
        "5_3": { onceOff: 390, weekly: 351, fortnightly: 351, monthly: 371 },

        // Continue the bedroom increment; recurring prices use 10% / 10% / 5% discounts.
        "6_1": { onceOff: 390, weekly: 351, fortnightly: 351, monthly: 371 },
        "6_2": { onceOff: 420, weekly: 378, fortnightly: 378, monthly: 399 },
        "6_3": { onceOff: 450, weekly: 405, fortnightly: 405, monthly: 428 }
      }
    },

    deep: {
      hourly: 80,
      rates: {
        "1_1": 320,
        "2_1": 400,
        "3_1": 520,
        "4_1": 600,
        "5_1": 680,

        "2_2": 480,
        "3_2": 560,
        "4_2": 640,
        "5_2": 720,

        "3_3": 600,
        "4_3": 680,
        "5_3": 720,

        // Continue each bathroom row's increase from four to five bedrooms.
        "6_1": 760,
        "6_2": 800,
        "6_3": 760
      }
    },

    vacate: {
      hourly: 80,
      rates: {
        noCarpet: {
          "1_1": 400,
          "2_1": 480,
          "3_1": 640,
          "4_1": 720,
          "5_1": 760,

          "2_2": 600,
          "3_2": 720,
          "4_2": 800,
          "5_2": 880,

          "3_3": 720,
          "4_3": 800,
          "5_3": 960,

          "6_1": 800,
          "6_2": 960,
          "6_3": 1120
        },

        withCarpet: {
          "1_1": 480,
          "2_1": 560,
          "3_1": 750,
          "4_1": 850,
          "5_1": 900,

          "2_2": 700,
          "3_2": 850,
          "4_2": 900,
          "5_2": 1000,

          "3_3": 850,
          "4_3": 950,
          "5_3": 1100,

          "6_1": 950,
          "6_2": 1100,
          "6_3": 1250
        }
      }
    }
  }
};
